import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

// eslint-disable-next-line no-unused-vars
import {
  FleetTypes,
  CarInterface,
  CarReportInterface,
  CarSettingsInterface,
} from './types';

// List Cars
export const listCarsRequest = (payload: {
  body?: object;
  filtering?: boolean;
  isCsvFull?: boolean;
}) => action(FleetTypes.LIST_CARS_REQUEST, payload);

export const listCarsSuccess = (payload: {
  carsList: CarInterface[];
  carsListFull: CarInterface[];
  totalCount: number;
  isCsvFull?: boolean;
}) => action(FleetTypes.LIST_CARS_SUCCESS, payload);

export const listCarsFailure = () => action(FleetTypes.LIST_CARS_FAILURE);

// List All Cars
export const listAllCarsRequest = (payload: object) =>
  action(FleetTypes.LIST_ALL_CARS_REQUEST, payload);

export const listAllCarsSuccess = (payload: { allCarsList: CarInterface[] }) =>
  action(FleetTypes.LIST_ALL_CARS_SUCCESS, payload);

export const listAllCarsFailure = () =>
  action(FleetTypes.LIST_ALL_CARS_FAILURE);

// Get Car
export const getCarRequest = (payload: object) =>
  action(FleetTypes.GET_CAR_REQUEST, payload);

export const getCarSuccess = (payload: { carData: CarInterface }) =>
  action(FleetTypes.GET_CAR_SUCCESS, payload);

export const getCarFailure = () => action(FleetTypes.GET_CAR_FAILURE);

// Filter Monitoring Cars
export const filterMonitoringCarsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(FleetTypes.FILTER_MONITORING_CARS_REQUEST, payload);
export const filterMonitoringCarsSuccess = (payload: {
  filterCarsList: CarInterface[];
  totalCount: number;
}) => action(FleetTypes.FILTER_MONITORING_CARS_SUCCESS, payload);
export const filterMonitoringCarsFailure = () =>
  action(FleetTypes.FILTER_MONITORING_CARS_FAILURE);

// Filter Cars
export const filterCarsRequest = (payload: {
  body: Object;
  filtering?: boolean;
}) => asyncAction(FleetTypes.FILTER_CARS_REQUEST, payload);
export const filterCarsSuccess = (payload: {
  filterCarsList: CarInterface[];
  totalCount: number;
}) => action(FleetTypes.FILTER_CARS_SUCCESS, payload);

export const filterCarsFailure = () => action(FleetTypes.FILTER_CARS_FAILURE);

// Create Car
export const createCarRequest = (payload: object) =>
  action(FleetTypes.CREATE_CAR_REQUEST, payload);

export const createCarSuccess = (payload: { carData: CarInterface }) =>
  action(FleetTypes.CREATE_CAR_SUCCESS, payload);

export const createCarFailure = () => action(FleetTypes.CREATE_CAR_FAILURE);

// Create Cars in Batch (CSV import)
export const createCarsBatchRequest = (payload: { cars: object[] }) =>
  action(FleetTypes.CREATE_CARS_BATCH_REQUEST, payload);

// Update Car
export const updateCarRequest = (payload: object) =>
  action(FleetTypes.UPDATE_CAR_REQUEST, payload);

export const updateCarSuccess = (payload: { carData: CarInterface }) =>
  action(FleetTypes.UPDATE_CAR_SUCCESS, payload);

export const updateCarFailure = () => action(FleetTypes.UPDATE_CAR_FAILURE);

// Delete Car
export const deleteCarRequest = (payload: object) =>
  action(FleetTypes.DELETE_CAR_REQUEST, payload);

export const deleteCarSuccess = () => action(FleetTypes.DELETE_CAR_SUCCESS);

export const deleteCarFailure = () => action(FleetTypes.DELETE_CAR_FAILURE);

// Car reports
export const listCarsReportRequest = (payload: object) =>
  action(FleetTypes.LIST_CARS_REPORT_REQUEST, payload);

export const listCarsReportSuccess = (payload: {
  reports: CarReportInterface;
}) => action(FleetTypes.LIST_CARS_REPORT_SUCCESS, payload);

export const listCarsReportFailure = () =>
  action(FleetTypes.LIST_CARS_REPORT_FAILURE);

// Car reports Quantity
export const listCarsReportQuantityRequest = (payload: object) =>
  action(FleetTypes.LIST_CARS_QUANTITY_REPORT_REQUEST, payload);

export const listCarsReportQuantitySuccess = (payload: {
  reportsQuantity: CarReportInterface;
}) => action(FleetTypes.LIST_CARS_QUANTITY_REPORT_SUCCESS, payload);

export const listCarsReportQuantityFailure = () =>
  action(FleetTypes.LIST_CARS_QUANTITY_REPORT_FAILURE);

// Get Car Settings
export const getCarSettingsRequest = (payload: object) =>
  action(FleetTypes.GET_CAR_SETTINGS_REQUEST, payload);

export const getCarSettingsSuccess = (payload: {
  carSettingsData: CarSettingsInterface;
}) => action(FleetTypes.GET_CAR_SETTINGS_SUCCESS, payload);

export const getCarSettingsFailure = () =>
  action(FleetTypes.GET_CAR_SETTINGS_FAILURE);

// Update Car Settings
export const updateCarSettingsRequest = (payload: object) =>
  action(FleetTypes.UPDATE_CAR_SETTINGS_REQUEST, payload);

export const updateCarSettingsSuccess = (payload: {
  carSettingsData: CarSettingsInterface;
}) => action(FleetTypes.UPDATE_CAR_SETTINGS_SUCCESS, payload);

export const updateCarSettingsFailure = () =>
  action(FleetTypes.UPDATE_CAR_SETTINGS_FAILURE);
